"use strict";
/**
 * HTML escaping utilities for safe HTML/email template rendering (CR-008)
 *
 * メール通知テンプレート等でユーザー/管理者制御の文字列を HTML 本文へ埋め込む際、
 * エスケープしないと HTMLインジェクション/XSS（フィッシングリンク・トラッキング画像・
 * 一部メールクライアントでのスクリプト実行）が成立する。本モジュールの関数で
 * 全ユーザー入力をエスケープし、href の URL はスキーム検証を行う。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeHtml = escapeHtml;
exports.sanitizeUrl = sanitizeUrl;
const HTML_ESCAPE_MAP = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
};
/**
 * HTML 特殊文字をエスケープする（テキスト/属性値の両コンテキストで安全）。
 * null/undefined は空文字に変換する。
 */
function escapeHtml(value) {
    if (value === null || value === undefined) {
        return '';
    }
    return String(value).replace(/[&<>"']/g, (ch) => HTML_ESCAPE_MAP[ch]);
}
// 制御文字（NUL〜US および DEL）。href 難読化（例: "java\nscript:"）対策で除去する。
const CONTROL_CHARS = /[\x00-\x1F\x7F]/g;
/**
 * URL を href 属性で安全に使えるよう検証・エスケープする。
 * - http / https スキームのみ許可（javascript:, data:, vbscript: 等は無効化して空文字を返す）
 * - 難読化対策として制御文字を除去
 * - 最後に HTML 属性向けエスケープを適用（`"` や `&` による属性ブレイクアウトを防止）
 *
 * @returns 安全な URL 文字列。許可されないスキームの場合は空文字。
 */
function sanitizeUrl(url) {
    if (url === null || url === undefined) {
        return '';
    }
    const cleaned = String(url).replace(CONTROL_CHARS, '').trim();
    if (!/^https?:\/\//i.test(cleaned)) {
        return '';
    }
    return escapeHtml(cleaned);
}
//# sourceMappingURL=html.js.map